module.exports = __webpack_public_path__ + "img/sky.75bbfe3.jpg";